<div class="custom-scrollbar-css">
  <h2 class="modal-title" style="margin-top: 3%; margin-left: 65px; font-weight: bold;">

    Configuration d'alarme d'accident
  </h2>

  <div class="container-fluid mt-3">

    <mat-horizontal-stepper>
      <form class="mt-4" [formGroup]="registerForm" (submit)="submitForm()">
        <mat-step label="Alarmes sur évènements " state="phone">
          <div>
            <div class="row">

              <div class="col-6 col-md-12 w-100">
                <h1 class="p-2 " style="border-bottom: 1px solid #d5cccc;">

                  Niveau
                </h1>

                <div class="row d-flex  justify-content-start form-group  ">
                  <mat-radio-group formControlName="level">
                    <div class="pad">
                      <span class="span-form fif"> Compagnie </span>
                      <mat-radio-button class="example-radio-button fif" [value]=1>
                        <div class="EnableDiv" style="margin-top: 5%;">
                          <mat-form-field appearance="fill" class="example-full-width appearance-fill w-100 mb-3">
                              <!-- <mat-label>Compagnie</mat-label> -->
                              <input matInput #input value="{{name}}">
                            </mat-form-field>
                          </div>
                      </mat-radio-button>
                    </div>

                    <div class="pad">
                      <span class="span-form fif"> Véhicule </span>
                      <mat-radio-button class="example-radio-button fif" [value]=0 >
                        <app-units (selectdUnits)="setEntityIDVEh($event)"></app-units>
                          <!-- <app-units  [selecteChoice]="selectedUnit?.nom"></app-units> -->
                      </mat-radio-button>
                    </div>
                  </mat-radio-group>
                </div>
              </div>


            </div>

          </div>
        </mat-step>

        <mat-step label="Notifications" state="notif">
          <div class="row">

            <div class="col-6 col-md-12 w-100">
              <h1 class="p-2 " style="border-bottom: 1px solid #d5cccc;">

                Notifications
              </h1>
              <br>
              <div class="row">
                <div class="col-md-2">
                </div>
                <div class="col-md-10">

                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-11 w-100">
                      <!--   <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 20px;">
                              <mat-label>Rechercher contact</mat-label>
                              <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
                              <mat-icon matSuffix>search</mat-icon>
                          </mat-form-field> -->


                      <form>
                        <mat-form-field appearance="fill"style="width: 100%; margin-bottom: 20px;"
                           class="appearance-fill"
                          style="width: 100%; margin-bottom: 20px;" (click)="hiddencontenu()">
                          <mat-label>Sélectionner un contact déjà existant </mat-label>
                          <!--(keyup)="applyFilterer($event)"-->
                          <input type="text" aria-label="Number" matInput (keyup)="applyFilter1($event)"
                            (click)="hiddencontenu2()" [formControl]="myControl" [matAutocomplete]="auto" />



                          <button mat-button matSuffix mat-icon-button>
                            <mat-icon placement="bottom" ngbTooltip="Actualiser la liste des contacts"
                              (click)="refrech()">refresh
                            </mat-icon>

                          </button>
                          <button mat-button matSuffix mat-icon-button (click)="hiddencontenu()">
                            <mat-icon placement="bottom" ngbTooltip="Lister les contacts">filter_list</mat-icon>

                          </button>


                          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">


                            <table class="table-hover" mat-table [dataSource]="dataSourcet">
                              <!-- Position Column -->
                              <ng-container matColumnDef="position">
                                <th mat-header-cell *matHeaderCellDef>Contact.</th>
                                <td (click)="getContact_notif()" mat-cell *matCellDef="let elementt" [ngClass]="{
                                        highlight: selectedRowIndex2 == elementt.id
                                      }" (click)="getItemDetails2(elementt)">
                                  <strong> Name: {{ elementt.first_name }} </strong> <br />
                                  Id: {{ elementt.id }} <br />

                                  Email: {{ elementt.email }}
                                </td>
                              </ng-container>

                              <tr class="d-none" mat-header-row *matHeaderRowDef="displayedColumnst"></tr>
                              <tr mat-row *matRowDef="let elementt; columns: displayedColumnst"></tr>
                            </table>

                            <mat-option class="d-none"> </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </form>





                    </div>
                    <div class="col-1 w-100">
                      <img style="height: 85%;" placement="left" ngbTooltip="Ajouter un nouveau contact"
                        data-toggle="collapse" (click)="add_contact()" data-target="#collapseMalasngoding"
                        aria-expanded="false" aria-controls="collapseMalasngoding" src="assets/icons/addcontact.svg" />
                      <!-- <img placement="bottom" ngbTooltip="Confirmer" (click)="submitcontact()"
                        *ngIf="new_contact == true && registerFormContact.valid" width="40px" height="40px"
                        src="https://img.icons8.com/ios/64/4a90e2/ok--v1.png" /> -->

                    </div>
                  </div>
                  <div class="collapse" id="collapseMalasngoding">
                    <!--         <mat-radio-group aria-label="Select an option" >
                          <div class="row" style=" margin-bottom: 15px;">
                              <div class="col-md-3">
                              </div>
                              <div class="col-md-3">
                                  <mat-radio-button  (click)="select_contact()" value="1">Sélectionner un contact existant
                                  </mat-radio-button>

                              </div>
                              <div class="col-md-3">
                                  <mat-radio-button (click)="add_contact()" value="2">Créer un nouveau contact</mat-radio-button>

                              </div>
                              <div class="col-md-3">
                              </div>
                          </div>
                          </mat-radio-group>
                      <div class="row">
                          <div class="col-md-4">

                          </div>
                          <div class="col-md-4">
                              <mat-form-field *ngIf="new_contact == false" appearance="fill" style=" width: 100%; margin-bottom: 20px;">
                                  <mat-label>Contacts</mat-label>
                                  <mat-select [formControl]="contacts">
                                    <mat-option *ngFor="let contact of contactList" [value]="contact">{{contact.first_name}}</mat-option>
                                  </mat-select>
                                </mat-form-field>
                          </div>
                          <div class="col-md-4">

                          </div>
                      </div> -->

                    <div class="row">
                      <div class="col-md-4">

                      </div>
                      <div class="col-md-4">




                        <!--    <form>
                            <mat-form-field appearance="fill" (click)="hiddencontenu()">
                              <mat-label>Filtrer par contact</mat-label>

                              <input type="text" aria-label="Number"  matInput (keyup)="applyFilter1($event)" (click)="hiddencontenu2()"
                                [formControl]="myControl" [matAutocomplete]="auto" />



                              <button mat-button matSuffix mat-icon-button>
                                <mat-icon matTooltip="Actualiser les données des véhicules " (click)="refrech()">refresh</mat-icon>

                              </button>
                              <button mat-button  matSuffix mat-icon-button (click)="hiddencontenu()">
                                <mat-icon matTooltip="Liste vehicule">filter_list</mat-icon>

                              </button>


                              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">


                                <table class="table-hover" mat-table [dataSource]="dataSourcet">

                                  <ng-container matColumnDef="position">
                                    <th mat-header-cell *matHeaderCellDef>Contact.</th>
                                    <td (click)="getContact_notif()" mat-cell *matCellDef="let elementt" [ngClass]="{
                                        highlight: selectedRowIndex2 == elementt.id
                                      }" (click)="getItemDetails2(elementt)">
                                      <strong> Name: {{ elementt.first_name }} </strong> <br />
                                      Id: {{ elementt.id }} <br />

                                      Email: {{ elementt.email }}
                                    </td>
                                  </ng-container>

                                  <tr class="d-none" mat-header-row *matHeaderRowDef="displayedColumnst"></tr>
                                  <tr mat-row *matRowDef="let elementt; columns: displayedColumnst"></tr>
                                </table>

                                <mat-paginator #secondPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

                                <mat-option class="d-none"> </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
                          </form> -->



                        <!--   <mat-form-field *ngIf="new_contact == false" appearance="fill"
                          style=" width: 100%; margin-bottom: 20px;">
                          <mat-label>Contacts</mat-label>
                          <mat-select formControlName="contacts">
                            <mat-option *ngFor="let contact of contactList" [value]="contact">{{contact.first_name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field> -->
                      </div>
                      <div class="col-md-4">

                      </div>
                    </div>



                    <form class="mt-4" [formGroup]="registerFormContact" (submit)="submitcontact()">
                      <div class="row" *ngIf="new_contact == true">
                        <div class="col-md-6" style=" margin-bottom: 20px;">
                          <mat-form-field class="example-full-width appearance-fill" appearance="fill"
                            style="width: 100%;">
                            <mat-label>Nom</mat-label>
                            <input matInput formControlName="last_name" required>
                            <mat-error *ngIf="registerFormContact.get('last_name').hasError('pattern')">Veuillez saisir
                              une format valide !
                            </mat-error>
                            <mat-error *ngIf="registerFormContact.get('last_name').hasError('required')">
                              Prénom est <strong>Obligatoire</strong>
                            </mat-error>
                          </mat-form-field>

                        </div>
                        <div class="col-md-6" style=" margin-bottom: 20px;">
                          <mat-form-field class="example-full-width appearance-fill" appearance="fill"
                            style="width: 100%;">
                            <mat-label>Prénom</mat-label>
                            <input matInput formControlName="first_name" required>
                            <mat-error *ngIf="registerFormContact.get('first_name').hasError('pattern')">Veuillez saisir
                              une format valide !
                            </mat-error>
                            <mat-error *ngIf="registerFormContact.get('first_name').hasError('required')">
                              Prénom est <strong>Obligatoire</strong>
                            </mat-error>
                          </mat-form-field>

                        </div>

                      </div>

                      <div class="row" *ngIf="new_contact == true">
                        <div class="col-md-6" style=" margin-bottom: 20px;">
                          <mat-form-field class="example-full-width appearance-fill" appearance="fill"
                            style="width: 100%;">
                            <mat-label>Courrier électronique</mat-label>

                            <input matInput type="email" formControlName="email" [errorStateMatcher]="matcher" required>

                            <mat-error *ngIf="registerFormContact.get('email').hasError('email')">Veuillez saisir une
                              format valide !
                            </mat-error>
                            <mat-error *ngIf="registerFormContact.get('email').hasError('required')">
                              Email est <strong>Obligatoire</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-md-6" style=" margin-bottom: 20px;">
                          <mat-form-field class="example-full-width appearance-fill" appearance="fill"
                            style="width: 100%;">
                            <mat-label>Numéro de téléphone</mat-label>
                            <input matInput formControlName="gsm_number">
                          </mat-form-field>
                        </div>

                      </div>
                    </form>
                    <mat-icon placement="bottom" ngbTooltip="Confirmer" (click)="submitcontact()"
                    *ngIf="new_contact == true && registerFormContact.valid"
                    style="color: #031f3d; margin-left: 96%;
                    margin-top: -1%;">check_circle_outline</mat-icon>



                  </div>




                     <table mat-table [dataSource]="dataSourceC" class="mat-elevation-z8">

                    <!--- Note that these columns can be defined in any order.
                              The actual rendered columns are set as a property on the row definition" -->


                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef>

                      </th>

                      <td (click)="selection.toggle(element)" mat-cell *matCellDef="let element">
                        <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)"
                          [aria-label]="checkboxLabel(element)">
                        </mat-checkbox>
                      </td>
                    </ng-container>

                    <!-- ID Column -->
                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef> ID. </th>
                      <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                    </ng-container>

                    <!-- Prénom Column -->
                    <ng-container matColumnDef="first_name">
                      <th mat-header-cell *matHeaderCellDef> Prénom </th>
                      <td mat-cell *matCellDef="let element"> {{element.first_name}} </td>
                    </ng-container>

                    <!-- Nom Column -->
                    <ng-container matColumnDef="last_name">
                      <th mat-header-cell *matHeaderCellDef> Nom </th>
                      <td mat-cell *matCellDef="let element"> {{element.last_name}} </td>
                    </ng-container>

                    <!-- delete Column -->
                    <ng-container matColumnDef="delete">
                      <th mat-header-cell *matHeaderCellDef> Actions </th>
                      <td mat-cell *matCellDef="let element ; let i= index" style="justify-content: end;">
                        <img (click)="Delete_contact(i)" placement="left" ngbTooltip="Supprimer contact"
                        src="assets/icons/icon-delete.svg" />

                      </td>
                    </ng-container>

                    <!-- email Column -->
                    <ng-container matColumnDef="email">
                      <th mat-header-cell *matHeaderCellDef> email </th>
                      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>





                </div>
              </div>

            </div>


          </div>
        </mat-step>

        <!-- Icon overrides. -->
       <!--  <ng-template matStepperIcon="phone">
          <mat-icon>notifications</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="chat">
          <mat-icon>schedule</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="notif">
          <mat-icon>notifications_active</mat-icon>
        </ng-template> -->
      </form>
    </mat-horizontal-stepper>







  </div>
</div>
<div class=" justify-content-end d-flex" style="margin-right: 2%; margin-bottom: 40px; margin-top: 2%;">
  <a [ngClass]="{colorIconActive : registerForm.valid    ,colorIconInactive : !registerForm.valid   }"
  class="savebtn mr-2" type="submit" (click)="submitForm()">Enregistrer</a>

  <a class="cancelbtn mr-2" type="submit" aria-pressed="true" (click)="onNoClick()">Annuler</a>
</div>
